import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipComponent } from './tooltip.component';
import { IconModule } from '@pc-ui/icon';

@NgModule({
  declarations: [TooltipComponent],
  imports: [CommonModule, IconModule],
  exports: [TooltipComponent],
})
export class TooltipModule {}
